import { BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { LayoutContext } from '../../context/LayoutContext'

export type TopContentProps = BoxProps & {}

const TopContent: React.FC<TopContentProps> = () => {
  const { state, dispatch } = React.useContext(LayoutContext)
  const pageType = '/'

  React.useEffect(() => {
    const transition = state.transitionType
    // console.log(transition)
    if (transition) {
      switch (transition.state) {
        case 'pageWillAppear':
          if (transition.to === pageType) {
            dispatch({ type: 'updateTransition', value: 'pageDidAppear' })
          }
          break
        case 'pageWillDisappear':
          if (transition.from === pageType) {
            dispatch({ type: 'updateTransition', value: 'pageDidDisappear' })
          }
          break
        default:
          break
      }
    }
  }, [state.transitionType])
  return <></>
}

export default TopContent
